module.exports = __webpack_public_path__ + "media/images/front/dr_yamanaka_r-99dcc72fce3d2e30f5bb77080fef4fc5.jpg";